{
  "version": 1,
  "asset_id": "cb9af802-3a08-4cfb-b784-f05847f710c9",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/cb9af802-3a08-4cfb-b784-f05847f710c9/blog-upload-1280.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/cb9af802-3a08-4cfb-b784-f05847f710c9/blog-upload-1280.avif",
  "original_filename": "blog-upload-1280.avif",
  "size": 15785,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:02:34Z"
}
